import { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const PlaylistDetails = lazy(() => import("@kaltura/mediaspace-features-playlist-details"));
export const render = getDsLayoutComponentRenderer(PlaylistDetails);
